export const pluralization = (singularKey, pluralKey, count, t) => t(count > 1 ? pluralKey : singularKey, { count });

export const getTranslatedTitle = (translations, locale) => {
  if (!translations?.length) {
    return '';
  }

  return (
    translations.find(translation => translation.locale_code === locale)?.text ||
    translations.find(translation => translation.main)?.text ||
    translations[0].text
  );
};
